import { Component, OnInit, OnDestroy } from '@angular/core';
import { AuthService } from '../../shared/services/auth/auth.service'
import { Router, ActivatedRoute, RouterStateSnapshot } from '@angular/router';
import { TranslateService, LangChangeEvent } from '@ngx-translate/core';
import { StaticValueService } from '../../shared/services/static-value.service'
import * as io from 'socket.io-client';
import { Configuration } from '../../app.constants';
import { AssociateService } from '../../shared/services/associate.service'
import { NotificationService } from '../../shared/services/notification.service';
import { AssessmentsService } from '../../shared/services/assessments.service'
import { SocketService } from 'app/shared/services/socket.service';
@Component({
    selector: 'app-sidebar',
    templateUrl: './sidebar.component.html',
    styleUrls: ['./sidebar.component.scss']
})
export class SidebarComponent implements OnInit, OnDestroy {

    public navList: any;
    showSidebar = true;
    public currentUrl: String;
    public language = 'english'
    navLinks = [];
    serverApiUrl: any;
    public socket: any;
    public newAction: number = 0;
    public shouldIDisplayPeopleManagementExclamation = false;
    // need to false it
    public shouldIDisplayProfileReview = true;
    public Allobservables = [];

    constructor(public authService: AuthService, public router: Router,
        public translateService: TranslateService,
        public staticService: StaticValueService,
        public AssessmentsServiceObj: AssessmentsService,
        public assoService: AssociateService,
        public notificationService: NotificationService,
        public config: Configuration,
        private socketService: SocketService,
    ) {


        this.serverApiUrl = this.config.ServerApiUrl;
        router.events.subscribe((val) => this.currentUrl = router.routerState.snapshot.url);
        // .subscribe((url: any) => console.log(url));
        this.translateService.setDefaultLang('english');
        this.language = this.translateService.currentLang ? this.translateService.currentLang : 'english';
        // this.socket = io(this.config.SocketUrl);
        // this.socket.on(`new-action-center-${this.authService.user.associateId}`, function (action) {
        //     this.newAction++;
        // }.bind(this));

        //   this.socket.on(`action-update-${this.authService.user.associateId}`,function(action) {
        //       console.log('action sidebar',action,this.newAction);
        //       this.newAction-=action;
        //       this.newAction = this.newAction>0 ? this.newAction: 0;
        //   }.bind(this));
        // this.socketLisner();
          
    }

    socketLisner() {
        const obs1 = this.socketService.initObs.subscribe(res => {
            if (res) {
                this.socketService.sendInit(this.authService.user.associateId);
            }
        });
        const obs2 = this.socketService.actionUpdatedObs.subscribe(action => {
            this.assoService.getAssociate(this.authService.user.associateId).subscribe(associate => {
                this.newAction = associate['data'][0].unreadNewActions;
            });
        })

        //   this.socket.on(`action-update-${this.authService.user.associateId}`,function(action) {
        //       console.log('action sidebar',action,this.newAction);
        //       this.assoService.getAssociate(this.authService.user.associateId).subscribe(associate => {
        //         this.newAction = associate['data'][0].unreadNewActions;
        //     })
        //   }.bind(this));

        // const obs3= this.socketService.actionUpdatedObs.subscribe(number=>{
        //     this.newAction -= number;
        //     this.newAction = this.newAction>0 ? this.newAction: 0;
        // });

        this.Allobservables.push(obs1);
        this.Allobservables.push(obs2);
        // this.Allobservables.push(obs3);
    }

    checkForPeopleManagementExclamation() {
        this.AssessmentsServiceObj.getAssocsToAssess({
            search: '',
            company: '',
            assessed: true,
            needAssessment: true
        }
        ).then(data => {
            let assocsToAssess = data['assocsToAssess'];
            let isAssessmentActionRequired = false;
            let isCalibrationActionRequired = false;
            let isAssessmentsOpen = false;
            let isCalibrationOpen = false;
            assocsToAssess.forEach(indAssess => {
                if (!(indAssess.assessments.line.isPlanned && indAssess.assessments.line.isAssessed && indAssess.assessments.line.isLeadershipDone)) {
                    isAssessmentActionRequired = true;
                }
            });

            let assocsToValid = data['assocsToValid'];

            // assocsToValid = assocsToValid.filter(value => {
            //     let isFunctional = false;
            //     value.assessments.higherManagers.forEach(indManager => {
            //         if(indManager.managerType === 'Functional' && indManager.doneById === this.authService.user.associateId){
            //             isFunctional = true;
            //         }
            //     });
            //     return isFunctional;
            // });

            assocsToValid.forEach(indAssoc => {
                indAssoc.assessments.higherManagers.forEach(indManager => {
                    if (indManager.doneById === this.authService.user.associateId) {
                        if ((indAssoc.assessments.line.isPlanned && indAssoc.assessments.line.isAssessed && indAssoc.assessments.line.isLeadershipDone)) {
                            if (!(indManager.isPlanned && indManager.isLeadershipDone)) {
                                isCalibrationActionRequired = true;
                            }
                        }
                    }
                });
            });
            this.AssessmentsServiceObj.isAssessmentsOn().then(isAssessmentOn => {
                if (isAssessmentOn['isAssessmentOn']) {
                    let assessStartDate = new Date(isAssessmentOn['details']['assessmentStart']).getTime();
                    let assessmentEndDate = new Date(isAssessmentOn['details']['assessmentEnd']).getTime();
                    let calibrationStart = new Date(isAssessmentOn['details']['calibrationStart']).getTime();
                    let calibrationEnd = new Date(isAssessmentOn['details']['calibrationEnd']).getTime();
                    let currTime = new Date().getTime();
                    if (currTime > assessStartDate && currTime < assessmentEndDate) {
                        isAssessmentsOpen = true;
                    }
                    if (currTime > calibrationStart && currTime < calibrationEnd) {
                        isCalibrationOpen = true;
                    }
                }
                this.shouldIDisplayPeopleManagementExclamation = false;
                if (isAssessmentsOpen && isAssessmentActionRequired) {
                    this.shouldIDisplayPeopleManagementExclamation = true;
                }
                if (isCalibrationOpen && isCalibrationActionRequired) {
                    this.shouldIDisplayPeopleManagementExclamation = true;
                }
            }).catch(err => {
                console.log(err);
            });
        }).catch(err => {
            console.log(err);
        });
    }

    ngOnInit() {

        this.AssessmentsServiceObj.shouldIDisplayProfileReview().then(res => {
            if (res['shouldIDisplayProfileReview']) {
                AssessmentsService.shouldIDisplayProfileReviewBeh.next(true);
            } else {
                AssessmentsService.shouldIDisplayProfileReviewBeh.next(false);
            }
        }).catch(err => {
            console.log('err');
        });

        AssessmentsService.shouldIDisplayProfileReviewObs.subscribe(res => {
            this.shouldIDisplayProfileReview = res;
        }, err => {
            console.log(err);
        });

        AssessmentsService.refreshSidebarExclamationIconObs.subscribe(res => {
            this.checkForPeopleManagementExclamation();
        }, err => {
            console.log(err);
        });

        this.assoService.getAssociate(this.authService.user.associateId).subscribe(associate => {
            this.newAction = associate['data'][0].unreadNewActions;
        })
        this.navList = this.authService.user.clientAcl['navViews'];
        for (let key in this.navList) {
            if (key !== null) {
                let navOptions = {
                    key: key,
                    value: this.navList[key].label,
                    icon: this.navList[key].icon
                };
                this.navLinks.push(navOptions);
            }
        }
    }

    ngOnDestroy(): void {
        this.socketService.disconnect(this.authService.user.associateId);
        this.Allobservables.forEach(obs => {
            obs.unsubscribe();
        })
    }
    languageChange(lang: string) {
        this.translateService.use(lang);
        this.language = lang;
        this.staticService.setLanguage(lang);
    }

    // routeClick(route){
    //     if(route==='Action Center'){
    //         this.newAction = 0;
    //         this.notificationService.readAllunreadAction(this.authService.user.associateId);
    //     }
    // }
}
